export default {"src":"/_next/static/media/warning-triangle.773a4d0b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};